<div class="_bg-grayscale-white">
    <app-nav class="_sticky _top-0 _z-50 _block _border-b _shadow-bottom" 
        [publicNavLogoUrlOverride]="companyLogo">
    </app-nav>
    <div class="listing-container _flex _flex-col _items-center" *ngIf="listing">
        <div class="md:_container _mx-auto _grid md:_gap-4 _grid-cols-12">
            <div class="_col-span-12 sm:_col-span-8 _px-2 md:_px-0">
                <app-listing-hotel 
                    #listingHotelComponent
                    *ngIf="listing.asset.assetType === AssetType.Hotel"
                    [listing]="listing"
                    [travelDates]="travelDates"
                    (onSuiteSelect)="updateSelectedSuite($event)"
                    (onSuiteThumbnailData)="updateHotelSuitesThumbnails($event)">
                </app-listing-hotel>

                <app-listing-property 
                    *ngIf="listing.asset.assetType === AssetType.Property" 
                    [listing]="listing">
                </app-listing-property>
            </div>
            <div class="_w-auto sm:_col-span-4 _pr-2 md:_pr-0">
                <div class="_drawer _drawer-no-toggle-btn  sm:_sticky sm:_top-listing-nav-offset _overflow-scroll _h-screen _no-scrollbar"
                    [ngClass]="{ '_drawer-open': openBookingPanel }">
                    <div class="_relative _h-full _overflow-y-scroll _no-scrollbar _pb-30">

                        <div class="_flex _justify-end _w-full sm:_hidden _px-4 _pt-4">
                            <button class="_button-reset _pr-0"
                            (click)="openMobileBookingPanel(false, $event)">
                                <i class="fa-sharp fa-light fa-chevrons-right"></i>
                            </button>
                        </div>

                        <div class="_max-w-600px _mx-auto">
                            <div class="_panel _bg-grayscale-white _gap-4 sm-max:_border-0 sm-max:_shadow-none _py-6">
                                <div *ngIf="listing.asset.assetType === AssetType.Hotel"
                                    class="_w-full" 
                                    [ngClass]="{_hidden: selectedSuite?.hotelSuiteId}">
                                    <div class="_mb-6 _w-full _text-center">
                                        <div class="_h3 _mb-2">Hotel Suites</div>
                                        <div class="_text-md">To see availability and rates please select a suite.</div>    
                                    </div>
                                    <div class="_flex _flex-col _gap-4">
                                        <div *ngFor="let suite of hotelSuitesThumbnailData; let index = index" 
                                            class="_flex _flex-row _gap-4 _items-center _w-full _border _shadow-sm _min-h-16 _cursor-pointer hover:_bg-primary-1-tint-4"
                                            (click)="suiteThumbnailSelect(index)">
                                            <div class="_placeholder-3-2 _rounded-none _min-w-24">
                                                <img *ngIf="suite.image" [source]="suite.image" app-imagekit transform="tr:w-120,h-80,fo-auto" alt="Hotel suite">
                                            </div>
                                            <div class="_flex _flex-col _gap-1">
                                                <div class="_text-md _font-bold">{{suite.name}}</div>
                                                <div *ngIf="suite.maximumOccupancy" class="_text-sm _text-primary-1-tint-50">{{suite.maximumOccupancy}} Guests</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="_w-full _text-center" [ngClass]="{_hidden: !selectedSuite?.hotelSuiteId && listing.asset.assetType !== AssetType.Property}">
                                    <div *ngIf="listing && travelDates && listing.asset.assetType === AssetType.Property" class="_w-full">

                                        <div class="_flex _flex-col _w-full _gap-4">
                                            <div class="_flex _items-center _justify-center xs-max:_mb-2">
                                                <app-listing-host [listingId]="listing.listingId" class="_border _border-primary-1-tint-50"></app-listing-host>
                                            </div>
                                            
                                            <span class="_flex _flex-col _items-center xs:_ml-4 _justify-center _gap-1">
                                                <div class="_h3 _font-bold">{{listing.summary.title}}</div>
                                                <div class="_text-primary-1-tint-50">
                                                    <span>{{listing.summary.city}}, </span>
                                                    <app-country-code [countryCode]="listing.summary.countryCode"></app-country-code>
                                                </div>
                                            </span>

                                            <span class="_text-lg _mt-6">
                                                Best available rate
                                                <span class="_font-bold"><app-booking-price [fees]="lowFeeRange"></app-booking-price></span>
                                                <span>per night</span>
                                            </span>
                                        </div>
                                    </div>

                                    <div *ngIf="listing && listing.asset.assetType === AssetType.Hotel" class="_w-full" >
                                        <div class="_flex _flex-col _w-full _gap-4">
                                            <div class="_flex _items-center _justify-center xs-max:_mb-2">
                                                <app-listing-host [listingId]="listing.listingId" class="_border _border-primary-1-tint-50"></app-listing-host>
                                            </div>
                                            
                                            <span class="_flex _flex-col _items-center xs:_ml-4 _justify-center _gap-1">
                                                <div class="_h3 _font-bold">{{listing.summary.title}}</div>
                                                <div *ngIf="listing.summary?.subtitle" class="_h4">{{listing.summary.subtitle}}</div>
                                                <div class="_text-primary-1-tint-50">
                                                    <span>{{listing.summary.city}}, </span>
                                                    <app-country-code [countryCode]="listing.summary.countryCode"></app-country-code>
                                                </div>
                                            </span>

                                            <span class="_text-lg _mt-6">
                                                Best available rate
                                                <span class="_font-bold"><app-booking-price [fees]="lowFeeRange"></app-booking-price></span>
                                                <span>per night</span>
                                            </span>
                                        </div>

                                        <!-- TODO: Set minimum booking rate for hotel (not suite)-->
                                        <ng-container *ngIf="!selectedSuite?.hotelSuiteId">
                                            <div class="_flex _flex-col _gap-8 _px-4 _py-8">
                                                <div class="_text-sm _text-center">View each suite for rates and instant bookings
                                                </div>

                                                <span class="_text-lg _text-center">
                                                    Best available rate
                                                    <span class="_font-bold">
                                                        <app-booking-price [fees]="fees"></app-booking-price>
                                                    </span>
                                                    <ng-container *ngIf="!travelDates.checkin && !travelDates.checkout">
                                                        per night
                                                    </ng-container>
                                                    <div class="_text-sm _text-primary-1-tint-50 _mt-2">(low season, minimum guests)</div>
                                                </span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="listing && (listing.asset.assetType === AssetType.Hotel && selectedSuite?.hotelSuiteId) || listing.asset.assetType === AssetType.Property">
            <div class="_fixed _bottom-0 _left-0 _w-full _p-3 _bg-primary-1 _z-10 _border-t _border-transparency-black-25 _shadow-top _text-white sm:_hidden">
                <div class="_relative _w-full _h-full _text-center _flex _flex-col _gap-2">
                    <app-button (click)="openBookingPanel = true" type="primary-dark" modifierClassNames="_w-full _max-w-600px _mx-auto">
                        Best available rate
                    </app-button>
                </div>
            </div>
        </ng-container>
    </div>
</div>
